import { AsidePosition } from '@sprinklr/spaceweb-charts/components/chartWrapper/types';
import { Orientation } from '@sprinklr/spaceweb-charts/types';

export function getOrientationFromPosition(asidePosition: AsidePosition): Orientation {
    return asidePosition === 'bottom' || asidePosition === 'top' ? 'horizontal' : 'vertical';
}
